import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class LevelRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): void {
		if (this.accountService.isDemoAccount) {
			this.navigationService.transitionToRoute('index');
			return;
		}
		document.body.id = 'page-account-level';
	}
}
